import { NamedItemInt } from '../common/namedItem'

enum SmsStatus {
  Delivered,
  Undelivered,
  Failed,
  Received,
}

export default SmsStatus

export const SmsStatuses: NamedItemInt[] = [
  {
    name: 'Delivered',
    id: SmsStatus.Delivered,
  },
  {
    name: 'Undelivered',
    id: SmsStatus.Undelivered,
  },
  {
    name: 'Failed',
    id: SmsStatus.Failed,
  },
  {
    name: 'Received',
    id: SmsStatus.Received,
  },
]